<template>
<div class="k-page-content">
	<el-tabs v-model="activeName" class="box-eltab">
		<el-tab-pane label="部门管理" name="first">
			<div class="k-page-common">
				<div class="k-common-header">
					<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
						<el-form :inline="true" :model="searchForm" size="mini">
							<el-form-item label="部门名称">
								<el-input v-model="searchForm.department_name" placeholder="请填写部门名称" clearable></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
								<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="k-common-con">
					<div class="k-table-wrapper">
						<div class="k-table-toolbar" style="margin-top:0;">
							<div>
								<el-button type="primary" size="mini" @click="addDepartmentOpen" v-if="$parent.$parent.isAuthAction('admin/users/department/createdepartment')">添加部门</el-button>
							</div>
						</div>
						<div class="k-table-con">
							<el-table
								:data="tableData.data"
								style="width: 100%"
								row-key="id"
								:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
								border
								stripe
								ref = "table"
								highlight-current-row
								@sort-change="sortChange"
								:height="tableHeight">
							
							<el-table-column
									fixed
									prop="department_name"
									label="部门名称"
									min-width="200">
							</el-table-column>
							<el-table-column
									prop="company_name"
									label="所属公司"
									min-width="200">
							</el-table-column>
							<el-table-column
									prop="department_parent"
									label="所属父级"
									min-width="200">
							</el-table-column>
							<el-table-column
									prop="department_level"
									label="所属层级"
									min-width="100">
							</el-table-column>
							<el-table-column
									prop="create_time"
									label="创建时间"
									width="200"
									sortable="custom">
							</el-table-column>
							<el-table-column
									prop="update_time"
									label="修改时间"
									width="200"
									sortable="custom">
							</el-table-column>
							<el-table-column
									fixed="right"
									label="操作"
									min-width="80">
								<template slot-scope="scope">
									<el-button  v-if="$parent.$parent.isAuthAction('admin/users/department/updatedepartment')" @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
									<el-button  v-if="$parent.$parent.isAuthAction('admin/users/department/deletedepartment')" @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination
							background
							ref="pagination"
							@current-change="handleCurrentChange"
							:current-page="tableData.page | number"
							:page-size="tableData.pagesize | number"
							layout="prev, pager, next, total"
							:total="tableData.total | number">
						</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</el-tab-pane>
	</el-tabs>
    <!--添加部门-->
	<el-dialog
	  title="添加部门"
	  :visible.sync="addFormVisiable"
	  :close-on-click-modal="false"
	  width="40%">
		  <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px" v-loading="loading">
			  <div>
				  <el-form-item label="部门名称" prop="department_name">
					<el-input v-model="addForm.department_name" placeholder="请填写部门名称" clearable></el-input>
				  </el-form-item>
				  <el-form-item label="所属父级">
					<el-cascader
						v-model="addForm.department_parent"
					    :options="options.department_options"
					    :props="{ checkStrictly: true, label:'department_name', value:'id' }"
					    clearable></el-cascader>
				  </el-form-item>
			  </div>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="addDepartment" :size='size'>提交</el-button>
			<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
		  </span>
	</el-dialog>
    <!--编辑部门-->
	<el-dialog
	  title="编辑部门"
	  :visible.sync="editFormVisiable"
	  :close-on-click-modal="false"
	  width="40%">
		  <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px" v-loading="loading">
			  <div>
				<el-form-item label="部门名称" prop="department_name">
					<el-input v-model="editForm.department_name" placeholder="请填写部门名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="所属父级">
					<el-cascader
					v-model="editForm.department_parent"
					:options="options.department_options"
					:props="{ checkStrictly: true, label:'department_name', value:'id' }"
					clearable></el-cascader>
				</el-form-item>
			  </div>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleTableEdit" :size='size'>提交</el-button>
			<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
		  </span>
	</el-dialog>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
		  loading:false,
		  activeName: 'first',
          size:'mini',
          options: {
              department_options:[]
          },
          searchForm: {
              department_name: '',
          },
          resetSearch: {
              department_name: '',
          },
          addForm: {
              department_name: '',
              department_parent: []
          },
          editForm: {
			  id:'',
              department_name: '',
              department_parent: []
          },
          rules: {
              addForm: {
                  'department_name': [
                      {required: true, message: '请填写部门名称', trigger: ['blur']},
                      {max: 15, message: '请填写正确的部门名称，长度不超过 15', trigger: ['blur']}
                  ]
              },
              editForm: {
                  'department_name': [
                      {required: true, message: '请填写部门名称', trigger: ['blur']},
                      {max: 15, message: '请填写正确的部门名称，长度不超过 15', trigger: ['blur']}
                  ]
              }
          },
          tableData: {
              total: 0,
              pagesize: 15,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm);
  },
  methods: {
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/users/department/getdepartmentlist',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
			   }else{
				  this.$message.error(res.msg);
			   }
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
		  this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
		  this.doSearch();
		},
		// 排序
		sortChange(e) {
		  var order;
		  var prop = e.prop;
		  if (e.order == 'ascending') {
			  order = 'asc';
		  } else if (e.order == 'descending') {
			  order = 'desc';
		  } else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
		  }
		  this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
		  this.handleSearch(this.searchForm, val);
		},
		// 添加部门弹窗
		addDepartmentOpen(){
			this.addForm = {
				department_name: '',
				department_parent: []
			}
			this.getDepartmentOption()
		    this.addFormVisiable = true;
		},
		// 添加部门
		addDepartment() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/users/department/createdepartment',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '添加部门成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		// 打开编辑部门弹窗
		handleTableEditOpen(row) {
			this.getDepartmentOption()
			this.$api.get('/admin/users/department/getdepartmentinfo',{id:row.id}).then(res => {
				  if (res.code === 0) {
					  this.$set(this,'editForm',res.data)
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		// 编辑部门
		handleTableEdit() {
		  this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/users/department/updatedepartment',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						 this.handleSearch('',this.tableData.page);
						  this.$message({
							  showClose: true,
							  message: '部门信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		// 删除部门
		handleTableDelete(row) {
		  this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
		  }).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/users/department/deletedepartment', {id:row.id}).then(res => {
				  if (res.code === 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该部门已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
		  }.bind(this))
		},
		//获取部门下拉
		getDepartmentOption(){
			this.$api.get('/admin/users/department/getdepartmentsearch').then(res => {
				if (res.code === 0) {
				  this.options.department_options = res.data;
				} else {
				  this.$message.error(res.msg);
				}
				this.loading = false
			})
		}
  },
}
</script>